import styled from 'styled-components'

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
`

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 16px;
`

export const BackButton = styled.div`
  padding: 8px 8px 16px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  gap: 10px;
  .anticon {
    font-size: 18px;
    cursor: pointer;
  }
`

export const FormButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  gap: 8px;
`

export const SettingWrapper = styled.div`
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  font-size: 14px;
  ${({ oneCol }) => oneCol
    ? `
      flex-direction: column;
      > div {
        width: 100%;
        border: none;
      }
    `
    : ''}
`

export const BasicSettingWrapper = styled.div`
  width: 380px;
  padding: 24px;
  border-right: 1px solid rgba(0,0,0,.1);
`

export const CustomSettingWrapper = styled.div`
  width: calc(100% - 380px);
  padding: 24px;

  .ant-empty-description {
    color: rgba(0,0,0,.3);
  }
`

export const SubTitle = styled.div`
  font-weight: 600;
  padding-bottom: ${({ section }) => section ? '8px' : '24px'};
  cursor: default;
`

export const HorizontalFormWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  > div {
    flex-basis: 0;
    flex-grow: 1;
  }
  
  .ant-form-item {
    margin-bottom: 0px;
  }
`

export const CounterTitle = styled.div`
  display: flex;
  gap: 8px;
  padding-bottom: 8px;
`

export const LoadingWrapper = styled.div`
  position: absolute;
  width: -webkit-fill-available;
  height: -webkit-fill-available;
  background: rgba(240,242,245,.8);
  z-index: 999;
  display: flex;
  justify-content: center;
`

export const Description = styled.div`
  padding-left: 38px;
  cursor: default;
  font-size: 14px;
  color: rgba(0,0,0,.4);
`

export const DashboardWrapper = styled.div`
  display: flex;
  height: max-content;
  margin-top: ${({ adminMode, noDragAndDrop }) => adminMode ? '24px' : noDragAndDrop ? '0px' : '16px'};
  gap: 8px;
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const DashboardColumn = styled.div`
  background: ${({ drag }) => drag ? 'rgba(229,232,236,.4)' : ''};
  ${({ width }) => width ? `width: ${width}` : 'flex: 1'};
`

export const DashboardItemWrapper = styled.div`
  userSelect: none;
  margin: 0 0 8px 0;
  height: -webkit-fit-content;
  background-color: ${({ drag }) => drag ? 'rgba(255,255,255,.8)' : 'rgba(255,255,255,1)'};
  color: black;
  border-radius: 6px;
  font-size: 14px;
  padding: 20px 16px;
  overflow-x: hidden;
  overflow-y: hidden;
`

export const ItemTitle = styled.div`
  font-weight: 500;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0,0,0,.07);
  display: flex;
  justify-content: space-between;
`

export const ProfileContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  position: relative;
`

export const ProfilePicWrapper = styled.div`
  border: 1px solid rgba(0,0,0,.1);
  padding: 3px;
  width: fit-content;
  margin: auto;
  border-radius: 50%;
  margin-bottom: 16px;
`

export const ContactsWrapper = styled.div`
  border-top: 1px solid rgba(0,0,0,.1);
  padding-top: 8px; 
  cursor: pointer;
  img {
    width: 28px;
    height: 28px;
    margin-right: 3px;
  }
`

export const PIIContent = styled.div`
  padding-top: 12px;
  .ant-statistic {
    padding-bottom: 6px;
  }
  .ant-statistic-title {
    font-size: 13px;
    margin: 0px;
  }
  .ant-statistic-content {
    font-size: 14px;
  }
`

export const FootprintContent = styled.div`
  margin-top: 20px;
  .ant-timeline .ant-timeline-item {
    padding-bottom: 16px;
  }
  .ant-timeline .ant-timeline-item-last {
    // height: 16px;
    padding-bottom: 0;
  }
`

export const SummaryContent = styled.div`
  margin-top: 10px;
  .ant-statistic-content .ant-statistic-content-prefix, .ant-statistic-content .ant-statistic-content-suffix {
    color: rgba(0,0,0,.4);
    font-size: 16px;
  }
  .ant-statistic-content .ant-statistic-content-prefix {
    margin-right: 8px;
  }
  .ant-statistic-content .ant-statistic-content-suffix {
    margin-left: 8px;
  }
`

export const PieChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding-top: 16px;
  width: 100%;
  max-width: 450px;
`

export const ColumnChartWrapper = styled.div`
  // height: 240px;
  margin: 24px 8px 0px;
`

export const WidthSettingWrapper = styled.div`
  margin: 0px 4px 8px;
  display: flex;
  gap: 8px;
  font-size: 14px;
  flex-wrap: wrap;
  div { margin: auto 0px; }
`

export const EditDelWrapper = styled.div`
  display: flex;
  color: rgba(0,0,0,.4);
  ${({ profile }) => profile
    ? `
        position: absolute;
        top: 0;
        right: 0;
      `
    : ''}

  div {
    padding-left: 6px;
    cursor: pointer;
    &:hover {
      color: var(--primary);
    }
  }
`

export const ShowMore = styled.span`
  font-size: 13px;
  cursor: pointer;
  &:hover {
    color: var(--primary);
  }
`

export const MultiColorWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`

export const UpdatedAtWrapper = styled.div`
  font-weight: 400;
  font-size: 12px;
`

export const EmptyPlaceholder = styled.div`
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
`

export const CrossDataSettingWrapper = styled.div`
  max-height: calc(100vh - 300px);
  overflow: scroll;
`

export const RelationshipWrapper = styled.div`
  background: rgba(0,0,0,.03);
  padding: 16px 16px 0px;
  border-radius: 4px;
  margin: 0 0 16px;
`
export const RelationshipRow = styled.div`
  display: flex;
  gap: 16px;
  > div {
    width: 100%;
  }
`

export const DashboardSummaryWrapper = styled.div`
  display: flex;
  padding: 8px 0;
  > div:not(:last-child) {
    border-right: 1px solid rgba(0,0,0,.2);
  }
`

export const DashboardSummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 4px;
  width: 100%;
`

export const JourneyWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 16px;
  border: 1px solid rgba(0,0,0,.2);
  padding: 8px 16px;
  border-radius: 2px;
  overflow: scroll;
`

export const JourneyItem = styled.div`
  width: 540px;
  border-right: 1px solid rgba(0,0,0,.2);
  padding: 0 16px 16px 0;
`

export const JourneyTwoRowItems = styled.div`
  display: flex;
  gap: 16px;
  width: 524px;
  > div {
    width: 100%;
  }
`
